const prefix = (type) => `cleverkids/api/${type}`;

export const UNAUTHORIZED = prefix('UNAUTHORIZED');
export const SERVER_ERROR = prefix('SERVER_ERROR');
export const NOT_FOUND = prefix('NOT_FOUND');
export const CONNECTION_ERROR = prefix('CONNECTION_ERROR');
